/** Tipos dos recursos de campanhas */
export interface RecursoCampanhaTipo {
    id: number;
    nome: string;
    nomePlural: string;
}

export const recursoCampanhaTipoInvestimento: RecursoCampanhaTipo = {
    id: 1,
    nome: 'Investimento',
    nomePlural: 'Investimentos'
};
export const recursoCampanhaTipoProduto: RecursoCampanhaTipo = {
    id: 2,
    nome: 'Produto',
    nomePlural: 'Produtos'
};
export const recursoCampanhaTipoServico: RecursoCampanhaTipo = {
    id: 3,
    nome: 'Serviço',
    nomePlural: 'Serviços'
};

export const recursoCampanhaTipos: RecursoCampanhaTipo[] = [
    recursoCampanhaTipoInvestimento,
    recursoCampanhaTipoProduto,
    recursoCampanhaTipoServico
];

/** Verifica se o tipo informado é igual a Investimento */
export function isTipoInvestimento(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === recursoCampanhaTipoInvestimento.id;
}

/** Verifica se o tipo informado é igual a Produto */
export function isTipoProduto(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === recursoCampanhaTipoProduto.id;
}

/** Verifica se o tipo informado é igual a Serviço */
export function isTipoServico(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === recursoCampanhaTipoServico.id;
}
